import {
  IconCalendarMonth,
  IconClipboardCheck,
  IconDoor,
  IconFile,
  IconFileText,
  IconFridge,
  IconHammer,
  IconMessage,
  IconMovie,
  IconPhoto,
  IconUsers,
  IconWallet,
  IconZip,
} from '@tabler/icons-react';

import { LinkGroupKey, MESSAGE_GROUP } from 'src/Components/EntityLinks/utils/entityLinkConstants';
import { LinkableEntityType } from 'src/Services/API/EntityLinks.api';

// Same iconography already used across the app for these entity types (see CreateMenu).
export const getGroupIcon = (groupKey: LinkGroupKey) => {
  switch (groupKey) {
    case LinkableEntityType.Task:
      return IconClipboardCheck;
    case LinkableEntityType.Contact:
      return IconUsers;
    case LinkableEntityType.VirtualFile:
      return IconFile;
    case LinkableEntityType.Expense:
      return IconWallet;
    case LinkableEntityType.Project:
      return IconHammer;
    case LinkableEntityType.CommunityFeedItem:
      return IconPhoto;
    case LinkableEntityType.Room:
      return IconDoor;
    case LinkableEntityType.Event:
      return IconCalendarMonth;
    case LinkableEntityType.InventoryItem:
      return IconFridge;
    case MESSAGE_GROUP:
      return IconMessage;
  }
};

export const getDocumentIcon = (mimeType?: string) => {
  if (!mimeType) return IconFile;
  if (mimeType.startsWith('image/')) return IconPhoto;
  if (mimeType.startsWith('video/')) return IconMovie;
  if (mimeType.startsWith('application/zip')) return IconZip;
  if (mimeType.startsWith('text/')) return IconFileText;
  return IconFile;
};

export const getDocumentIconColor = (mimeType?: string): string => {
  if (!mimeType) return 'gray';
  if (mimeType.startsWith('image/')) return 'grape';
  if (mimeType.startsWith('video/')) return 'pink';
  if (mimeType.startsWith('application/zip')) return 'yellow';
  if (mimeType.startsWith('text/')) return 'blue';
  return 'gray';
};
